module.exports = __webpack_public_path__ + "img/project-02-02.242936ec.png";